import React from 'react'

import {
  PlaceholderContainer,
  ImageContainer,
  Image,
  ContentContainer,
  Stripe,
  SmallStripe,
  MediumStripe,
  LongStripe
} from './styled'

const LoadingCardView = () => (
  <PlaceholderContainer>
    <ImageContainer>
      <Image />
    </ImageContainer>
    <ContentContainer>
      <Stripe />
      <SmallStripe />
      <MediumStripe />
      <LongStripe />
    </ContentContainer>
  </PlaceholderContainer>

)

LoadingCardView.propTypes = {}

LoadingCardView.defaultProps = {}

export default LoadingCardView
